// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"e6cde7c2","636":"7f3dc7e9"}[chunkId] + ".chunk.js";
};